<template>
    <div class="row mb-2">
        <div class="col-lg-2 col-md-4">
            <label for="sprint">Sprint</label>
            <dropdown name ="sprint"
                :disabled="loading" 
                :datasource="filters"
                :placeholder="resource('SprintPlanning_Filter_Sprint_Placeholder')"
                @input="$emit('filter-changed', $event)"
            />
        </div>
        <div class="col-lg-1 col-md-2 d-flex flex-column">
            <button class="btn btn-outline-secondary mt-auto" @click="$emit('refresh')" :disabled="loading" >
                <i class="fas fa-sync"></i> {{resource('Button_Refresh')}}
            </button>
        </div>
    </div>
</template>

<script>

//Util
import api from '../api';
import growler from '../../../Util/growler';

//Mixins
import resourceMixin from '../../../Util/Mixins/resources';

//Components
import Dropdown from '../../../Components/Inputs/Dropdown.vue';

export default {
    name: 'sprint-planning-filter',
    mixins: [resourceMixin],
    components: {
        Dropdown
    },
    beforeCreate() {
        const vm = this;

        api.getFilters().then(
            (filters) => {
                vm.filters = filters.map((filter) => {
                    return {
                        value: filter.id,
                        text: filter.name
                    };
                });
            },
            growler.bootstrapDanger
        );
    },
    data() {
        return {
            filters: []
        }
    },
    props: {
        loading: {
            type: Boolean,
            required: true
        }
    }
};
</script>

<style lang="scss" scoped>

</style>